import { render, staticRenderFns } from "./KusClientListVue.vue?vue&type=template&id=236c5acc"
import script from "./KusClientListVue.vue?vue&type=script&lang=js"
export * from "./KusClientListVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports